export var MarkType;
(function (MarkType) {
    MarkType["Timestamp"] = "ts";
    MarkType["Redaction"] = "redact";
    MarkType["Confidence"] = "conf";
    MarkType["AutoCorrect"] = "ac";
})(MarkType || (MarkType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["Document"] = "doc";
    NodeType["MonologueText"] = "mt";
    NodeType["MonologueDetails"] = "md";
    NodeType["Text"] = "text";
})(NodeType || (NodeType = {}));
export var TaggedMomentEntity;
(function (TaggedMomentEntity) {
    TaggedMomentEntity["Conference"] = "conference";
    TaggedMomentEntity["Transcript"] = "transcript";
})(TaggedMomentEntity || (TaggedMomentEntity = {}));
